import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8h1v8","key":"svg-0"}],["path",{"d":"M9 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M16 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0","key":"svg-2"}]]

const IconNumber100Small = createReactComponent('outline', 'number-100-small', 'Number100Small', __iconNode);

export default IconNumber100Small;